(function () {
    'use strict';
    angular.module('app').component('screeningFvm', {
        templateUrl: '@/screening/screeningFvm.component.html',
        bindings: {
            screeningGroup: '=',
            filter: '=',
            // To consider: Make the rows responsible, they already have access to onReload for answering the screening (including the attachments)
            open: '=?',
            download: '=?',
            accept: '=?',
            reopen: '=?',
            stop: '=?',
            onReload: '=?',
            identifier: '@',
            app: '@'
        },
        controller: ScreeningFvmController
    });

    ScreeningFvmController.$inject = ['$rootScope', '$scope'];
    function ScreeningFvmController($rootScope, $scope) {
        const $controller = this;
        $controller.$onInit = initialize;
        function initialize() {
            $scope.t = $rootScope.translations;
            $scope.codePartners = $rootScope.codePartners;
        }
    }
})();